/**
 * Portal Yol sekmesi — SVG pan/zoom (analyze road_v2_test.js ile uyumlu).
 */
export function setupPortalRoadSvgPanZoom(holder, svg) {
  if (!holder || !svg) return () => {};

  svg.classList.add('pp-detail-road-svg-inline');
  holder.classList.add('pp-detail-road-svg-pan-active');
  svg.style.background = '#ffffff';

  const vbParts = (svg.getAttribute('viewBox') || '0 0 960 720').split(/\s+/).map(Number);
  const viewBox = {
    x: vbParts[0] || 0,
    y: vbParts[1] || 0,
    w: vbParts[2] || 960,
    h: vbParts[3] || 720,
  };
  let dragging = false;
  let last = { x: 0, y: 0 };

  function apply() {
    svg.setAttribute('viewBox', [viewBox.x, viewBox.y, viewBox.w, viewBox.h].join(' '));
  }

  function pointerRect() {
    return svg.getBoundingClientRect();
  }

  function onWheel(event) {
    event.preventDefault();
    event.stopPropagation();
    const rect = pointerRect();
    if (!rect.width || !rect.height) return;
    const px = (event.clientX - rect.left) / rect.width;
    const py = (event.clientY - rect.top) / rect.height;
    const zoom = event.deltaY < 0 ? 0.85 : 1.18;
    const newW = viewBox.w * zoom;
    const newH = viewBox.h * zoom;
    const anchorX = viewBox.x + viewBox.w * px;
    const anchorY = viewBox.y + viewBox.h * py;
    viewBox.x = anchorX - newW * px;
    viewBox.y = anchorY - newH * py;
    viewBox.w = newW;
    viewBox.h = newH;
    apply();
  }

  function onMouseDown(event) {
    if (event.button !== 0) return;
    event.preventDefault();
    dragging = true;
    last = { x: event.clientX, y: event.clientY };
    holder.classList.add('is-dragging');
  }

  function onMouseMove(event) {
    if (!dragging) return;
    event.preventDefault();
    const rect = pointerRect();
    if (!rect.width || !rect.height) return;
    const dx = ((event.clientX - last.x) / rect.width) * viewBox.w;
    const dy = ((event.clientY - last.y) / rect.height) * viewBox.h;
    viewBox.x -= dx;
    viewBox.y -= dy;
    last = { x: event.clientX, y: event.clientY };
    apply();
  }

  function onMouseUp() {
    dragging = false;
    holder.classList.remove('is-dragging');
  }

  holder.addEventListener('wheel', onWheel, { passive: false });
  holder.addEventListener('mousedown', onMouseDown);
  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);

  return function cleanup() {
    holder.removeEventListener('wheel', onWheel);
    holder.removeEventListener('mousedown', onMouseDown);
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
    holder.classList.remove('pp-detail-road-svg-pan-active', 'is-dragging');
  };
}
